/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_Currencies {
    DKK = 10,
    EUR = 20,
    USD = 30,
    DEM = 40,
    NOK = 50,
}
